const getFirstErrorEntry = (value: unknown): string | undefined => {
  if (Array.isArray(value)) {
    return typeof value[0] === 'string' ? value[0] : undefined
  }
  return typeof value === 'string' ? value : undefined
}

export const resolveAcceptSuggestionError = (errorData: unknown): string | null => {
  const directMessage = getFirstErrorEntry(errorData)
  if (directMessage && (Array.isArray(errorData) || typeof errorData === 'string')) {
    return directMessage
  }

  if (!errorData || typeof errorData !== 'object' || Array.isArray(errorData)) {
    return null
  }

  const blueprintError = getFirstErrorEntry(
    (errorData as { blueprint?: { common?: unknown } }).blueprint?.common
  )
  if (blueprintError) {
    return blueprintError
  }

  for (const key of ['non_field_errors', 'date', 'accrual_date', 'posting_mode'] as const) {
    const message = getFirstErrorEntry((errorData as Record<string, unknown>)[key])
    if (message) {
      return message
    }
  }

  return null
}
